import * as React from "react";
import {Button, FormControl, FormGroup, MenuItem, Modal} from "react-bootstrap";
import {defineMessages, FormattedMessage, InjectedIntl, InjectedIntlProps, injectIntl} from "react-intl";
import {FormLabel} from "@material-ui/core";

interface State {
  showModal: boolean;
  name: string;
  title: string;
  abstractText: string;
}

interface Props extends InjectedIntl, InjectedIntlProps {
  disabled: boolean;
  initialTitle: string;
  onNameSet: (entry:{name: string, title: string, abstractText: string;}) => void;
}

const SET_STYLE_SET_NAME_BUTTON_MESSAGES = defineMessages({
  setStyleSetNameButtonDescription: {
    id: "studio.set-style-set-name-menuitem.description",
    defaultMessage: "Enter style set name",
  }
});

export function cleanId(text:string) {
  return text.replace(/\W/g,'_');
}

export class SetStyleSetNameButtonPresentation extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      name: "",
      title: "",
      abstractText: "",
    };
  }

  closeModal = () => this.setState({showModal: false});

  submitModal = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
      if (typeof this.props.onNameSet === "function") {
        if (this.state.name.trim().length>1) {
          this.props.onNameSet({name: this.state.name.trim(), title: this.state.title.trim(), abstractText: this.state.abstractText.trim()});
          this.closeModal();
        }
      }
   }

  openModal = () => this.setState({
    title: this.props.initialTitle,
    name: cleanId(this.props.initialTitle),
    showModal: true
  });

  private handleChange = (event: any) =>{
    event.preventDefault();
    const {name, value} = event.target;

    if (name==="title") {
      this.setState({
        title: value,
        name: cleanId(value)
      })
      return;
    }
    // @ts-ignore
    this.setState({
      [name]: value
    })
  }

  render() {

    const {disabled, intl} = this.props;
    return (
        <>
          <MenuItem disabled={disabled} onSelect={this.openModal} alt={intl.formatMessage(SET_STYLE_SET_NAME_BUTTON_MESSAGES.setStyleSetNameButtonDescription)}>
            <FormattedMessage id="studio.set-style-set-name-menuitem.text" defaultMessage="Add new style set" />
          </MenuItem>

            <Modal show={this.state.showModal} onHide={this.closeModal} bsSize="large" backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>
                  <FormattedMessage id="studio.set-style-set-name-menuitem.modal-header"
                                    defaultMessage="Enter Style Set Name"
                  />
                </Modal.Title>
              </Modal.Header>
              <form onSubmit={this.submitModal}>
              <Modal.Body>
                <FormGroup>
                  <FormLabel>
                    <FormattedMessage id="studio.set-style-set-name-menuitem.label-title"
                                      defaultMessage="Title:"
                    />
                  </FormLabel>
                  <FormControl autoFocus type="text" name="title" value={this.state.title} onChange={this.handleChange}/>
                </FormGroup>
                <FormGroup>
                  <FormLabel>
                    <FormattedMessage id="studio.set-style-set-name-menuitem.label-abstract"
                                      defaultMessage="Abstract:"
                    />
                  </FormLabel>
                  <FormControl type="text" name="abstractText" value={this.state.abstractText} onChange={this.handleChange}/>
                </FormGroup>
                <FormGroup>
                  <FormLabel>
                    <FormattedMessage id="studio.set-style-set-name-menuitem.label-name"
                                      defaultMessage="Name:"
                    />
                  </FormLabel>
                  <FormControl type="text" name="name" value={this.state.name} readOnly={true}/>
                </FormGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button  type="submit" >
                  <FormattedMessage
                      id="studio.set-style-set-name-menuitem.close"
                      defaultMessage="OK"
                  />
                </Button>
                <Button onClick={this.closeModal}>
                  <FormattedMessage
                    id="studio.set-style-set-name-menuitem.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
              </Modal.Footer>
            </form>
        </Modal>
        </>
    );
  }

}

export const MenuItemSetStyleSetName = injectIntl(SetStyleSetNameButtonPresentation);
